export interface TutorialHelper {
  getTutorialType(): Promise<TutorialType | undefined>;
}

export enum TutorialType {
  Video,
  Interactive,
}
